import React from 'react';
import { EmployeeRow } from '../../../services/p9301Api';
import { formatGender, formatDate } from '../helpers';

interface ResultTableProps {
  results: EmployeeRow[];
  count: number;
  queried: boolean;
}

const ResultTable: React.FC<ResultTableProps> = React.memo(({ results, count, queried }) => {
  if (!queried) {
    return (
      <div className="result-placeholder">
        請設定篩選條件後按「開始查詢」
      </div>
    );
  }

  if (results.length === 0) {
    return (
      <div className="result-placeholder">
        查無符合條件之員工資料
      </div>
    );
  }

  return (
    <div className="result-section">
      <div className="result-header">
        <span className="result-count">共 {count} 筆資料</span>
      </div>
      <div className="table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              <th style={{ width: 60 }}>#</th>
              <th style={{ width: 90 }}>員工代號</th>
              <th style={{ width: 100 }}>姓名</th>
              <th style={{ width: 120 }}>英文名</th>
              <th style={{ width: 80 }}>部門代號</th>
              <th style={{ width: 120 }}>部門名稱</th>
              <th style={{ width: 80 }}>職稱代號</th>
              <th style={{ width: 120 }}>職稱名稱</th>
              <th style={{ width: 80 }}>薪等代號</th>
              <th style={{ width: 100 }}>薪等名稱</th>
              <th style={{ width: 60 }}>性別</th>
              <th style={{ width: 100 }}>到職日</th>
              <th style={{ width: 100 }}>離職日</th>
              <th style={{ width: 120 }}>電話</th>
              <th style={{ width: 150 }}>Email</th>
            </tr>
          </thead>
          <tbody>
            {results.map((row, idx) => (
              <tr key={row.f901_01 || idx}>
                <td className="cell-center">{idx + 1}</td>
                <td>{row.f901_01}</td>
                <td>{row.f901_11}</td>
                <td>{row.f901_12}</td>
                <td>{row.f901_32}</td>
                <td>{row.dept_name}</td>
                <td>{row.f901_33}</td>
                <td>{row.job_title_name}</td>
                <td>{row.f901_51}</td>
                <td>{row.salary_grade_name}</td>
                <td className="cell-center">{formatGender(row.f901_14)}</td>
                <td>{formatDate(row.f901_31)}</td>
                <td>{formatDate(row.f901_34)}</td>
                <td>{row.f901_17}</td>
                <td>{row.f901_22}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
});

ResultTable.displayName = 'ResultTable';

export default ResultTable;
